import { render } from "./UIBtn.vue?vue&type=template&id=fd9805b6"
import script from "./UIBtn.vue?vue&type=script&lang=js"
export * from "./UIBtn.vue?vue&type=script&lang=js"

import "./UIBtn.vue?vue&type=style&index=0&id=fd9805b6&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__